import di from "@frameworks/web/components/features/LoginFlow/di/servicelocator";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import OtpPage from "./OtpPage";
import { useLocation, useNavigate } from "react-router-dom";
import ErrorExclamation from "@frameworks/web/components/generic/errorExclamation";
import config from "@frameworks/web/config/domain";
import DeviceContext from "@frameworks/web/components/generic/customHooks/indentifyDevice";
import MainDI from "@di";
import { loginScreenState } from "../constant";
const GuestLoginValidateMPIN = (props) => {
    const navigate = useNavigate();
    const location = useLocation();
    const device = DeviceContext();
    const dispatch = useDispatch();
    const locationState = location.state;
    const [serverError, setServerError] = useState({
        isOpen: false,
        msg: "",
    });
    const { data: guestValidateMPIN, loader: guestValidateMPINLoader, errorData: guestValidateMPINError, } = useSelector((state) => state.LoginFlow.guestValidateMPIN);
    const submitMPINForValidation = (mpin) => {
        var _a, _b;
        let payload = {
            pin: mpin,
            mob: ((_a = props === null || props === void 0 ? void 0 : props.guestLoginMpinPayload) === null || _a === void 0 ? void 0 : _a.mob)
                ? (_b = props === null || props === void 0 ? void 0 : props.guestLoginMpinPayload) === null || _b === void 0 ? void 0 : _b.mob
                : locationState === null || locationState === void 0 ? void 0 : locationState.mob,
            // props?.guestLoginMpinPayload !== undefined &&
            // props?.guestLoginMpinPayload !== null
            //   ? props?.guestLoginMpinPayload?.mob !== ""
            //     ? props?.guestLoginMpinPayload?.mob
            //     : ""
            //   : locationState !== undefined && locationState !== null
            //   ? locationState.mob
            //   : "",
            countryCode: "91",
        };
        di.login.GuestValidateMPIN(payload);
        if (!(device === null || device === void 0 ? void 0 : device.isDesktop)) {
            dispatch(MainDI.footer.updateShowMob_Menu(true));
            MainDI.header.RemoveHeaderData(true);
        }
    };
    const getInvalidPinSection = () => {
        if (!guestValidateMPINLoader && serverError.isOpen) {
            return (React.createElement(React.Fragment, null,
                React.createElement(ErrorExclamation, { errorMessage: serverError.msg, avoidBackground: true })));
        }
    };
    const customLinkFunction = () => {
        var _a, _b;
        let payload = {
            mobileNo: (props === null || props === void 0 ? void 0 : props.guestLoginMpinPayload) !== undefined &&
                (props === null || props === void 0 ? void 0 : props.guestLoginMpinPayload) !== null
                ? ((_a = props === null || props === void 0 ? void 0 : props.guestLoginMpinPayload) === null || _a === void 0 ? void 0 : _a.mob) !== ""
                    ? (_b = props === null || props === void 0 ? void 0 : props.guestLoginMpinPayload) === null || _b === void 0 ? void 0 : _b.mob
                    : ""
                : locationState !== undefined && locationState !== null
                    ? locationState.mob
                    : "",
            build: "web-pc",
            countryCode: "91",
            req: "generate",
        };
        di.login
            .guestRegister(payload)
            .then((val) => {
            if (val.status) {
                props.setScreenState(loginScreenState.GUEST_FORGOT_MPIN);
                props.setForgetFlow(true);
            }
            // navigate("/guest-validate-otp", {
            //   state: {
            //     mob: props?.guestLoginMpinPayload?.mob
            //       ? props.guestLoginMpinPayload?.mob
            //       : locationState?.mob,
            //     navigateTo: "/guest-forgot-pin",
            //     previousPath: location.pathname,
            //     pageHeading: "Forgot PIN",
            //     prevLocationTitle: "Forgot PIN",
            //   },
            // });
        })
            .catch((error) => { });
    };
    useEffect(() => {
        var _a;
        if (!guestValidateMPINLoader &&
            !guestValidateMPINError.isOpen &&
            guestValidateMPIN.registeredDate) {
            if (props === null || props === void 0 ? void 0 : props.skipRedirectNavigation) {
                if ((props === null || props === void 0 ? void 0 : props.setAfterLogin) !== undefined &&
                    (props === null || props === void 0 ? void 0 : props.setAfterLogin) !== null &&
                    typeof (props === null || props === void 0 ? void 0 : props.setAfterLogin) === "function") {
                    props === null || props === void 0 ? void 0 : props.setAfterLogin(true);
                }
            }
            else if ((props === null || props === void 0 ? void 0 : props.redirectUrlFromQueryParams) !== undefined &&
                (props === null || props === void 0 ? void 0 : props.redirectUrlFromQueryParams) !== null &&
                (props === null || props === void 0 ? void 0 : props.redirectUrlFromQueryParams) !== "") {
                window.location.href = (props === null || props === void 0 ? void 0 : props.redirectUrlFromQueryParams)
                    ? props === null || props === void 0 ? void 0 : props.redirectUrlFromQueryParams
                    : config.rootUrl;
            }
            else
                props.setScreenState(loginScreenState.GUEST_LOGIN_TRIAL);
        }
        else if (guestValidateMPINError === null || guestValidateMPINError === void 0 ? void 0 : guestValidateMPINError.isOpen) {
            setServerError({
                isOpen: guestValidateMPINError === null || guestValidateMPINError === void 0 ? void 0 : guestValidateMPINError.isOpen,
                msg: (_a = guestValidateMPINError === null || guestValidateMPINError === void 0 ? void 0 : guestValidateMPINError.error) === null || _a === void 0 ? void 0 : _a.getErrorMessageOrErrMsg(),
            });
        }
    }, [guestValidateMPINLoader, guestValidateMPINError, guestValidateMPIN]);
    return (React.createElement(OtpPage, { pageheading: "Continue as Guest", showTimer: false, customDescription: "Please enter your PIN", btnText: "Submit", 
        // errorSection={getInvalidPinSection()}
        otpErrorBlocked: getInvalidPinSection(), submit: submitMPINForValidation, noTimeOutIcon: true, errorState: (otp) => {
            if (otp.toString().length != 4)
                return false;
            else if (serverError.isOpen)
                return false;
            return true;
        }, customLinkUnderOTPInput: React.createElement("span", { className: "DMSanN_14_400 txt-midnight-blue text-decoration-underline hand_cursor", onClick: () => customLinkFunction() }, "Forgot PIN?"), setServerError: setServerError, serverError: serverError, customResendOTP: customLinkFunction }));
};
export default GuestLoginValidateMPIN;
